import React from 'react'

import styled, { useTheme } from 'styled-components'

import coinbg from "../../../assets/coinbg.jpg"
import { H3 } from '../../styleguide/typography'

import videoThumbnail from "../../../assets/videoThumbnail.jpg"

const Community = () => {

  const theme = useTheme();

  return (
    <StyledCommunity>
        <H3 
          align="center" 
          width="100%" color={theme.colors.white}
          maxWidth="1000px"
          textTransform="uppercase"
          size="2rem"
          mobileSize="0.85rem"
        >
          Mula finance is bringing the African 
          <span style={{ color: theme.colors.secondary }}> community </span>
          to your finger tips
        </H3>

        <VideoContainer>

        </VideoContainer>
    </StyledCommunity>
  )
}

export default Community

const StyledCommunity = styled.div`
    width: 100%;
    min-height: 544px;
    background-image: url(${coinbg});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 1rem;
    padding: 4.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3rem;

    @media (max-width: 768px) {
      padding: 2.5rem;      
    }
`

const VideoContainer = styled.div`
  width: 100%;
  max-width: 675px;
  height: 370px;
  background: #000;
  border-radius: 1rem;
  background-image: url(${videoThumbnail});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;

  @media (max-width: 768px) {
    height: 250px;
  }
`